export const routes = {
  interactivePlayground: '/playground/interactive',
}
